import React from "react";
import { Route } from "react-router-dom";
import PlaceV2 from "../pages/PlaceV2";

export const mainRoutes = (
  <>
    <Route path="/" element={<PlaceV2 />} />
    <Route path="*" element={<PlaceV2 />} />
  </>
);
